export default __webpack_public_path__ + "static/media/delivery.dfab76f2.svg";